function HandleHeaderAnchorClick(event) {
  if (event.currentTarget.classList.contains("lightning-header-anchor-desktop")) {
    var searchContainer = document.querySelector(".bridgman-header-search-desktop");
  } else {
    var searchContainer = document.querySelector(".bridgman-header-search-mobile");
  }

  if (searchContainer.classList.contains("hidden")) {
    searchContainer.classList.remove("hidden");
  } else {
    searchContainer.classList.add("hidden");
  }
}

function CloseHeaderDesktopSearch(event) {
  var searchContainer = event.currentTarget.closest(".bridgman-header-search");

  if (searchContainer.classList.contains("hidden")) {
    searchContainer.classList.remove("hidden");
  } else {
    searchContainer.classList.add("hidden");
  }
}

function handleMobHeaderHeight() {
  var mobNavBar = document.getElementById("mobileNavBar");
  mobNavBarHeight = mobNavBar.offsetHeight;
  var announcementBars = document.getElementsByClassName("bridgman-announcement-bar-container");
  if (announcementBars.length > 0) {
    var announcementHeight = announcementBars[0].offsetHeight;
  }
  var topRowHeader = document.querySelector(".bridgman-header-top-container");

  if (topRowHeader) {
    if (window.innerWidth <= 480) {
      if (announcementHeight) {
        topRowHeader.style.marginTop = mobNavBarHeight + announcementHeight + "px";
      } else {
        topRowHeader.style.marginTop = mobNavBarHeight + "px";
      }
    } else {
      topRowHeader.style.marginTop = "0px";
    }
  }
}

function InitHeaderScrollHide() {
  var header = document.querySelector(".header-section.bridgman-header");
  if (!header) return;

  var main = document.querySelector("main.bridgman-main-content");
  var tolerance = 5;
  var lastScroll = window.scrollY;
  var ticking = false;

  function setHidden(hidden) {
    header.classList.toggle("bridgman-header--hidden", hidden);
    document.body.classList.toggle("bridgman-header-is-hidden", hidden);
  }

  function update() {
    var scroll = Math.max(window.scrollY, 0);
    var delta = scroll - lastScroll;
    var searchOpen = document.querySelector(".bridgman-header-search:not(.hidden)");

    // AB test bridgman31: only the B variant gets the hide-on-scroll header
    var isVariant = document.documentElement.hasAttribute("data-bridgman31_B");
    var beforeMain = main ? main.getBoundingClientRect().top > 0 : scroll <= 100;

    if (!isVariant || beforeMain || searchOpen) {
      setHidden(false);
    } else if (delta > tolerance) {
      setHidden(true);
    } else if (delta < -tolerance) {
      setHidden(false);
    }

    if (Math.abs(delta) > tolerance) lastScroll = scroll;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true },
  );
}

window.addEventListener("DOMContentLoaded", function (e) {
  InitHeaderScrollHide();

  $(".lightning-header-anchor").on("click", function (event) {
    HandleHeaderAnchorClick(event);
  });
  $(".bridgman-header-search-desktop-close-button").on("click", function (event) {
    CloseHeaderDesktopSearch(event);
  });
});

window.addEventListener("load", function (e) {
  handleMobHeaderHeight();
});

window.addEventListener("resize", function (e) {
  handleMobHeaderHeight();
});
